import { IconButton, Avatar } from '@material-ui/core';
import DonutLargeOutlinedIcon from '@material-ui/icons/DonutLargeOutlined';
import ChatIcon from '@material-ui/icons/Chat'
import MoreVertOutlinedIcon from '@material-ui/icons/MoreVertOutlined';
import React from 'react'
import './Sidebar.css'
import { SearchOutlined } from '@material-ui/icons';
import SidebarChat from './SidebarChat';


function Sidebar(props) {

  return (
    <div className='sidebar' hidden={props.sidebarToggleState}>
    <div className='sidebar__header'>
        <Avatar src={require("assets/img/brand/argon-react.png").default}/>
        <div className='sidebar___headerRight'>
            <IconButton>
                <DonutLargeOutlinedIcon/>
            </IconButton>
            <IconButton>
                <ChatIcon/>
            </IconButton>
            <IconButton>
                <MoreVertOutlinedIcon/>
            </IconButton>
        </div>
    </div>
    <div className='sidebar__search'>
    <div className='sidebar__searchContainer'>
       <SearchOutlined/>
        <input placeholder='Search or start new chat' type='text'/>
    </div>
    </div>
    <div className="sidebar__chats">
        {props.message.map((messageItem)=>{
            return <SidebarChat message={messageItem} selectedMessage={props.selectedMessage} key={messageItem._id.phone} />
        })
        }
    
    <SidebarChat/>
    <SidebarChat/>
    </div>
    </div>
  )
}

export default Sidebar